import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {bindActionCreators} from 'redux';

import {PeriodInfo} from "./components";
import Admin from "./admin";
import NursingFacility from "./nursing-facility";
import * as selectors from "./sample.selectors";
import * as sampleActions from "./sample.actions";
import * as applicationActions from "../../application.actions";
import * as applicationSelectors from "../../application.selectors";
import {PrimaryButton} from "../../components";

const Container = styled.div`
`;

const StyledPeriodInfo = styled(PeriodInfo)`
  margin-bottom: 1em;
`;

const StyledPrimaryButton = styled(PrimaryButton)`
  margin-bottom: 1em !important;
`;

class Samples extends React.Component {
  state = {activeKey: 1};

  componentDidMount() {
    const {actions, period, match: {params}} = this.props;
    actions.fetchPeriod(params.id);
    actions.setPageTitle('PASRR Review');
    actions.setBreadcrumbs([
      {to: '/', title: 'Periods'},
      {active: true, title: period.description}
    ])
  }

  componentWillUpdate(nextProps) {
    const {period, actions} = nextProps;
    actions.setBreadcrumbs([
      {to: '/', title: 'Periods'},
      {active: true, title: period.description}
    ])
  }

  saveDueDate = id => date => this.props.actions.setDueDate(id, date);

  selectAnotherPeriod = () => {
    const {actions: {resetSampleUiState}, history} = this.props;
    resetSampleUiState();
    history.push('/');
  };

  render() {
    const {period, roles} = this.props;

    return (
      <Container>

        <StyledPrimaryButton onClick={this.selectAnotherPeriod}>Select Another Period</StyledPrimaryButton>

        <StyledPeriodInfo
          roles={roles}
          period={period}
          saveDueDate={this.saveDueDate(period.id)}
        />

        {roles.admin ? <Admin/> : <NursingFacility/>}
      </Container>
    );
  }
}

Samples.propTypes = {};

export default connect(
  (state) => ({
    period: selectors.currentPeriod(state),
    patients: selectors.includedPatients(state),
    roles: applicationSelectors.roles(state),
    userFacility: applicationSelectors.userFacility(state)
  }),
  dispatch => ({
    actions: bindActionCreators({
      ...applicationActions,
      ...sampleActions
    }, dispatch)
  })
)(Samples);


// WEBPACK FOOTER //
// ./src/modules/sample/index.js